<template>
  <div class="newsMergeBox">
    <div class="newsMergeList">
      <div
        class="newsMergeItem"
        v-for="item in pressCenter"
        :key="item.ID"
        @click="goNewsItem(item)"
      >
        <p class="newsMergeItemImg">
          <!-- <img src="../newsMain/img/pressthree.png" alt=""> -->
          <el-image class="CNewItemImgSelf" :src="item.TitlePic">
            <div slot="error" class="image-slot">
              <img src="~@/assets/img/noNews.png" alt="" />
            </div>
          </el-image>
        </p>
        <p class="newsMergeItemTitle">{{ item.Title | cutString }}</p>
        <p class="newsMergeItemTime">{{ item.AddTime | timeFormat }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// 获取新闻中心列表
import { getArticleApiIndex } from "@/api/news";
// 引入根路径
import request from "@/utils/request";
// 引入时间格式过滤
import { timeFormat } from "@/utils/myFilters";
import { cutString } from "@/utils/myCutString";
export default {
  props: ["newsId"],
  data() {
    return {
      pressCenter: [],
      swiper: {},
      TypeId: 1, // 新闻中心id
      PageIndex: 1 // 页数
    };
  },
  filters: {
    timeFormat,
    cutString
  },
  created() {},
  mounted() {
    this.TypeId = this.newsId;
    // 调用新闻中心获取
    this.getArticleApiIndex({ TypeId: this.TypeId, PageIndex: this.PageIndex });
    // this.swiper = new Swiper('.swiper-container', { // eslint-disable-line no-unused-vars
    // //   direction: 'vertical', // 垂直切换选项
    //   loop: true, // 循环模式选项
    //   slidesPerView: 3,
    //   spaceBetween: 10,
    //   // 如果需要分页器
    //   pagination: {
    //     el: '.swiper-pagination'
    //   },
    //   // 如果需要前进后退按钮
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    //   }
    // })
  },
  methods: {
    goNewsItem(item) {
      // this.$router.push(newsItem)
      this.$router.push({ path: `/newsItemNew/${item.ID}` });
    },

    // 获取新闻中心
    async getArticleApiIndex(data) {
      const res = await getArticleApiIndex(data);
      if (res.Msg === "获取成功") {
        this.pressCenter = res.Data;
        this.pressCenter.sort((a, b) => {
          return b.ID - a.ID;
        });
        this.pressCenter.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic;
        });
      }
      // console.log(this.pressCenter, '获取新闻中心')
    }
  }
};
</script>

<style lang="scss" scoped>
$md: 72/192 * 2;
.newsMergeBox {
  width: 750px / $md;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.newsMergeList {
  width: 690px / $md;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .newsMergeItem {
    width: 335px / $md;
    height: 345px / $md;
    background: #f8f8f8;
    margin-bottom: 26px / $md;
    p {
      margin-bottom: 16px / $md;
    }
    .newsMergeItemImg {
      width: 335px / $md;
      height: 209px / $md;
      margin: 0;
      img {
        width: 100%;
        height: 100%;
      }
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .newsMergeItemTitle {
      font-size: 22px / $md;
      height: 60px / $md;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      margin-left: 20px / $md;
      margin-right: 10px / $md;
    }
    .newsMergeItemTime {
      font-size: 20px / $md;
      margin-left: 20px / $md;
      margin-right: 10px / $md;
      color: #999999;
    }
  }
}
</style>
